// 文件传输链接工具

export function getApiBase() {
  return (process.env.REACT_APP_DELIVERY_API_URL || "").replace(/\/+$/, "");
}

export function buildTransferUrl(token) {
  const base = window.location.origin + window.location.pathname.replace(/\/+$/, "");
  return `${base}/#/t/${encodeURIComponent(token)}`;
}
